
const MovementKeys = {
    ThumbRight: 'ThumbRight',
    ThumbLeft: 'ThumbLeft',
    ThumbUp: 'ThumbUp',
    ThumbDown: 'ThumbDown'
};

export const OperationEnum = {
    MoveLeft: 'moveLeft',
    MoveRight: 'moveRight',
    MoveForward: 'moveForward',
    MoveBackward: 'moveBackward',

    Action: 'action',
    Hold: 'hold',
    Menu: 'menu',
    Teleport: 'teleport'
};

class KeybindingController {
    constructor() {
        this.browser = getBrowser();
        this.device = undefined;

        this.currentKeybindings = {};
    }

    async loadDefaultKeybinding() {
        try {
            this.currentKeybindings = await keybindingService.getDefaultKeyBinding(this.device);
        } catch(error) {
            VRMessageController.addMessage({text: 'Error getting keybinding', priority: VrMessagePriorityEnum.LOWPRIORITYINFO});
            console.log('Error getting default key binding', error);
        }
    }

    async loadKeybinding() {
        try {
            this.currentKeybindings = await keybindingService.getKeyBinding(this.device, this.browser);
        } catch(error) {
            VRMessageController.addMessage({text: 'Error getting keybinding', priority: VrMessagePriorityEnum.LOWPRIORITYINFO});
            console.log('Error getting key binding', error);
        }
    }

    handleVrDeviceChange(controller) {
        const device = controller.findControllerType();
        if (device !== this.device) {
            this.device = device;
            if (device !== undefined) {
                this.loadKeybinding();
            }
        }
    }

    onControllerKeyPressed(key, event) {
        const operation = this.getOperationForKey(key);

        switch (operation) {
            case OperationEnum.Action:
                onTriggerDownHandler(event);
                break;
            case OperationEnum.Hold:
                onGripPressedHandler(event);
                break;
            case OperationEnum.Teleport:
                onThumbButtonPressed(event);
                break;
            case OperationEnum.Menu:
                onControllerMenuPressed(event);
                break;
            default:
                break;
        }
    }

    onControllerKeyReleased(key, event) {
        const operation = this.getOperationForKey(key);

        switch (operation) {
            case OperationEnum.Action:
                onTriggerUpHandler(event);
                break;
            case OperationEnum.Hold:
                onGripReleasedHandler(event);
                break;
            case OperationEnum.Teleport:
                onThumbButtonReleased(event);
                break;
            case OperationEnum.Menu:
                onControllerMenuReleased(event);
                break;
            default:
                break;
        }
    }


    onTriggerDownHandler(event) {
        this.onControllerKeyPressed(ControllerKey.Trigger, event);
    }

    onTriggerUpHandler(event) {
        this.onControllerKeyReleased(ControllerKey.Trigger, event);
    }

    onControllerMenuPressed(event) {
        this.onControllerKeyPressed(ControllerKey.Menu, event);
    }

    onControllerMenuReleased(event) {
        this.onControllerKeyReleased(ControllerKey.Menu, event);
    }

    onAXButtonPressed(event) {
        this.onControllerKeyPressed(ControllerKey.AorX, event);
    }

    onAXButtonReleased(event) {
        this.onControllerKeyReleased(ControllerKey.AorX, event);
    }

    onBYButtonPressed(event) {
        this.onControllerKeyPressed(ControllerKey.BorY, event);
    }

    onBYButtonReleased(event) {
        this.onControllerKeyReleased(ControllerKey.BorY, event);
    }

    onThumbButtonPressed(event) {
        this.onControllerKeyPressed(ControllerKey.Thumb, event);
    }

    onThumbButtonReleased(event) {
        this.onControllerKeyReleased(ControllerKey.Thumb, event);
    }

    onGripPressedHandler(event) {
        this.onControllerKeyPressed(ControllerKey.Grip, event);
    }

    onGripReleasedHandler(event) {
        this.onControllerKeyReleased(ControllerKey.Grip, event);
    }

    onTouchpadPressedHandler(event) {
        this.onControllerKeyPressed(ControllerKey.Touchpad, event);
    }

    onTouchpadReleasedHandler(event) {
        this.onControllerKeyReleased(ControllerKey.Touchpad, event);
    }

    getButtonState(controller, operationName) {
        const key = this.currentKeybindings[operationName];
        if (!key) {
            return undefined;
        }

        return controller.getButtonState(key);
    }

    getMovementFromKeybinding(axisX, axisY) {
        const movement = {x: 0, y: 0};

        if (axisX > 0) {
            this.updateMovement(movement, MovementKeys.ThumbRight, Math.abs(axisX));
        } else if (axisX < 0) {
            this.updateMovement(movement, MovementKeys.ThumbLeft, Math.abs(axisX));
        }

        if (axisY > 0) {
            this.updateMovement(movement, MovementKeys.ThumbUp, Math.abs(axisY));
        } else if (axisY < 0) {
            this.updateMovement(movement, MovementKeys.ThumbDown, Math.abs(axisY));
        }

        return movement;
    }

    updateMovement(movement, key, length) {
        const moveOperation = this.getOperationForKey(key);

        switch (moveOperation) {
            case OperationEnum.MoveLeft:
                movement.x -= length;
                break;
            case OperationEnum.MoveRight:
                movement.x += length;
                break;
            case OperationEnum.MoveForward:
                movement.y += length;
                break;
            case OperationEnum.MoveBackward:
                movement.y -= length;
                break;
            default:
                break;
        }
    }

    getOperationForKey(keyToFind) {
        for (const [operation, key] of Object.entries(this.currentKeybindings)) {
            if (key === keyToFind) {
                return operation;
            }
        }
    }
}

const keybindingController = new KeybindingController();

export default keybindingController;
